module.exports = __webpack_public_path__ + "static/img/scare2.f97d37ed.png";